<template>
  <svg :width="width" :height="height" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g :fill="color">
      <path d="M9.91797 18.1953H23.5938C24.0508 18.1953 24.4492 17.8203 24.4492 17.3164C24.4492 16.8125 24.0508 16.4375 23.5938 16.4375H10.1172C9.44922 16.4375 9.03906 15.9688 8.93359 15.2539L8.74609 14.0234H23.6172C25.3281 14.0234 26.207 12.9688 26.4531 11.293L27.3906 5.09375C27.4141 4.94141 27.4375 4.75391 27.4375 4.64844C27.4375 4.08594 27.0156 3.69922 26.3711 3.69922H7.23438L7.01172 2.21094C6.89453 1.30859 6.56641 0.851562 5.37109 0.851562H1.25781C0.789062 0.851562 0.390625 1.26172 0.390625 1.73047C0.390625 2.21094 0.789062 2.62109 1.25781 2.62109H5.21875L7.09375 15.4883C7.33984 17.1523 8.21875 18.1953 9.91797 18.1953ZM25.4453 5.46875L24.6133 11.082C24.5195 11.8086 24.1328 12.2539 23.4414 12.2539L8.48828 12.2656L7.49219 5.46875H25.4453ZM10.8438 23.8906C11.8984 23.8906 12.7422 23.0586 12.7422 21.9922C12.7422 20.9375 11.8984 20.0938 10.8438 20.0938C9.77734 20.0938 8.93359 20.9375 8.93359 21.9922C8.93359 23.0586 9.77734 23.8906 10.8438 23.8906ZM21.8008 23.8906C22.8672 23.8906 23.7109 23.0586 23.7109 21.9922C23.7109 20.9375 22.8672 20.0938 21.8008 20.0938C20.7461 20.0938 19.8906 20.9375 19.8906 21.9922C19.8906 23.0586 20.7461 23.8906 21.8008 23.8906Z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
}
</script>
